// extracted by mini-css-extract-plugin
export default {"container":"PrizePoolTable_container__iihfU","header":"PrizePoolTable_header__5HjhV","table":"PrizePoolTable_table__SRxBP"};